import { render, staticRenderFns } from "./merchantsInformationEdit.vue?vue&type=template&id=0a830a7c&scoped=true&lang=pug&"
import script from "./merchantsInformationEdit.vue?vue&type=script&lang=js&"
export * from "./merchantsInformationEdit.vue?vue&type=script&lang=js&"
import style0 from "./merchantsInformationEdit.vue?vue&type=style&index=0&id=0a830a7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a830a7c",
  null
  
)

export default component.exports